import { SubscriptionPlanResponseDTO } from '@core/api/dtos/response/accounts/subscriptionPlan'
import {
	SubscriptionPlan,
	SubscriptionPlanMetadata,
} from '@core/api/entities/account/subscriptionPlan'

import { SubscriptionPlanPriceMapper } from './subscriptionPlanPriceMapper'

export class SubscriptionPlanMapper {
	static toEntity(dto: SubscriptionPlanResponseDTO): SubscriptionPlan {
		return SubscriptionPlan.create({
			id: dto.id,
			name: dto.name,
			description: dto.description,
			prices: dto.prices
				? SubscriptionPlanPriceMapper.toEntities(dto.prices.data)
				: undefined,
			metadata: SubscriptionPlanMetadata.create({
				canRequestPlaylists: dto.metadata.can_request_playlists,
				canRequestSchedules: dto.metadata.can_request_schedules,
				hasCampaignFeatures: dto.metadata.has_campaign_features,
				isLegacy: dto.metadata.is_legacy,
				isSelectable: dto.metadata.is_selectable,
				tier: dto.metadata.tier,
			}),
		})
	}

	static toEntities(dtos: SubscriptionPlanResponseDTO[]): SubscriptionPlan[] {
		return dtos.map(this.toEntity)
	}
}
